import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { HEADER_HEIGHT, ADMIN_HEADER_HEIGHT_MOBILE, MOBILE_NAV_ROW_HEIGHT } from './AdminHeaderBar.styles';

type AdminHeaderBarSpacerProps = Readonly<{
  /**
   * Set to `true` when the corresponding AdminHeaderBar has a `navigation`
   * prop with mobile tabs visible. This accounts for the extra row height
   * on mobile.
   *
   * @example
   * <AdminHeaderBar title="Website" navigation={<WebsiteTabNav />} />
   * <AdminHeaderBar.Spacer navigation />
   */
  navigation?: boolean;
}>;

/**
 * Spacer component for fixed AdminHeaderBar positioning.
 *
 * @example
 * <AdminHeaderBar title="Website" navigation={<WebsiteTabNav />} />
 * <AdminHeaderBar.Spacer navigation />
 *
 * @example
 * <AdminHeaderBar title="Settings" />
 * <AdminHeaderBar.Spacer />
 */
export const AdminHeaderBarSpacer: React.FC<AdminHeaderBarSpacerProps> = ({ navigation = false }) => (
  <Box
    height={{
      _: navigation ? pxToRem(ADMIN_HEADER_HEIGHT_MOBILE + MOBILE_NAV_ROW_HEIGHT) : HEADER_HEIGHT.base,
      md: HEADER_HEIGHT.md,
    }}
    flexShrink={0}
    aria-hidden="true"
    data-testid="admin-header-bar-spacer"
  />
);

AdminHeaderBarSpacer.displayName = 'AdminHeaderBarSpacer';
